import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const IconMenuPictureGallery = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M16.2 1.8V12.6H5.4V1.8H16.2ZM16.2 0H5.4C4.41 0 3.6 0.81 3.6 1.8V12.6C3.6 13.59 4.41 14.4 5.4 14.4H16.2C17.19 14.4 18 13.59 18 12.6V1.8C18 0.81 17.19 0 16.2 0ZM8.55 8.703L10.071 10.737L12.303 7.947L15.3 11.7H6.3L8.55 8.703ZM0 3.6V16.2C0 17.19 0.81 18 1.8 18H14.4V16.2H1.8V3.6H0Z" fill="#AEB4BE" />
        </SvgIcon>
    );
};